import { Doctor } from 'domain/entities/doctor-model'
import Heading from 'presentation/shared/components/Heading'
import TextField from 'presentation/shared/components/TextField'
import React from 'react'
import * as S from '../styles'

type Props = {
  doctor?: Doctor
}

export function AmbulatoryScheduleDoctorInfo({ doctor }: Props) {
  return (
    <>
      <Heading size="large" color="primary">
        Dados do Médico
      </Heading>
      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField
            label="Nome do médico"
            disabled
            value={doctor?.name}
            data-testid="ambulatoryScheduleDoctorName"
          />
        </div>
        <div style={{ maxWidth: '400px', display: 'flex', gap: '10px' }}>
          <TextField
            label="CRM"
            disabled
            value={doctor?.crm}
            data-testid="ambulatoryScheduleDoctorCRM"
          />
          <div style={{ maxWidth: '65px' }}>
            <TextField label="UF" disabled value={doctor?.crmUf} />
          </div>
        </div>
      </S.Form>
      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField
            label="Especialidade"
            disabled
            value={doctor?.specialty?.name}
            data-testid="ambulatoryScheduleDoctorSpecialty"
          />
        </div>
      </S.Form>
    </>
  )
}
